type CarePlanProps = {
  instructions: string
  title?: string
}

const CarePlan = ({ instructions, title = 'Care plan' }: CarePlanProps) => {
  return (
    <div className="mb-6">
      <p className="typography-caption text-neutral-500">{title}</p>
      <p className="typography-body-l whitespace-pre-line">{instructions}</p>
    </div>
  )
}

export default CarePlan
